export default __webpack_public_path__ + "static/media/score_bar_left.6e72fe3d.png";